import { defineComponent as r, computed as l, openBlock as i, createElementBlock as s, createElementVNode as t, toDisplayString as h, createCommentVNode as f, normalizeStyle as n, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "5fb3f1d4-4c3a-4c15-8937-d9a610f0e0eb" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#5fb3f1d4-4c3a-4c15-8937-d9a610f0e0eb)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#eee" d="m99 136.8 413 20v31.5l-35.9 66.1 36.2 68.4-.3 32.4-413 22z"></path><path fill="#496e2d" d="M512 156.8V0H0l122 156.8z"></path><path fill="#333" d="M167 188.3v134.5h345.3l-.3-134.5z"></path><path fill="#ffda44" d="M512 355.2V512H0l122-156.8z"></path><path fill="#a2001d" d="M0 0v512l256-256z"></path><path fill="#ffda44" d="m103.6 189.2 16.6 51h53.6l-43.4 31.6 16.6 51-43.4-31.5-43.4 31.5 16.6-51-43.4-31.6H87z"></path><path fill="#eee" d="M55.1 256h97v44.5h-97z"></path><path fill="#333" d="m170.5 205-15.7-15.8-51.2 51.2-51.1-51.2L36.7 205 88 256l-51.2 51.3 15.8 15.5 51.1-51 51.2 51 15.7-15.5-51.2-51.2z"></path>', 8), g = { fill: "none" }, z = ["r"], N = /* @__PURE__ */ r({
  __name: "mz",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), d = l(() => 256 + e.strokeWidth / 2);
    return (x, w) => (i(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", v, [
        e.flagName ? (i(), s("title", k, h(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=mz-d765a527.js.map
